export default __webpack_public_path__ + "static/media/david_cornwell.471e8e77.gif";